import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { usePageTitle } from 'utils/pageTitle';
import AdminLayout from 'pages/_rd_dashboard/AdminLayout';

import { fetchAdminUsers } from 'reducers/adminUsersReducer';

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

import Spinner from 'components/Spinner';
import Paginator from 'components/Paginator';

const AdminUsers = (props) => {
	usePageTitle('Admin | Users');
	const dispatch = useDispatch();
	let { users, isLoading, currentPage, totalPages } = useSelector((state) => ({
		users: state.adminUsers.data?.data || [],
		isLoading: state.adminUsers.isLoading,
		currentPage: state.adminUsers.data?.current_page,
		totalPages: state.adminUsers.data?.last_page,
	}));

	useEffect(() => {
		dispatch(fetchAdminUsers());
	}, [dispatch]);

	const openUserEditAdminModal = (userId) => {
		dispatch(openModal(MODAL_TYPES.USER_ADMIN_EDIT, { userId }));
	};

	const openUserCreateAdminModal = () => {
		dispatch(openModal(MODAL_TYPES.USER_ADMIN_CREATE));
	};

	const openEnterpriseOnboardingModal = () => {
		dispatch(
			openModal(MODAL_TYPES.ENTERPRISE_ONBOARDING, {
				onSuccess: () => {
					// Refresh user list after successful onboarding
					dispatch(fetchAdminUsers());
				},
			})
		);
	};

	const openFreeTrialOnboardingModal = () => {
		dispatch(
			openModal(MODAL_TYPES.FREE_TRIAL_ONBOARDING, {
				onSuccess: () => {
					// Refresh user list after successful onboarding
					dispatch(fetchAdminUsers());
				},
			})
		);
	};

	return (
		<AdminLayout>
			<div className="dashboard-portfolio">
				<h1>User Management</h1>
				{isLoading ? (
					<Spinner />
				) : (
					<div className="pb-4">
						<div className="mb-3">
							<button
								className="btn btn-primary me-2"
								onClick={openUserCreateAdminModal}
							>
								<i className="bi bi-person-plus me-2"></i>
								Invite New User
							</button>
							<button
								className="btn btn-dark me-2"
								onClick={openEnterpriseOnboardingModal}
							>
								<i className="bi bi-building-check me-2"></i>
								Onboard Enterprise Client
							</button>
							<button
								className="btn btn-secondary"
								onClick={openFreeTrialOnboardingModal}
							>
								<i className="bi bi-gift me-2"></i>
								Onboard Free Trial Client
							</button>
						</div>
						<div className="dashboard-table-wrapper">
							<table className="table table-striped table-rounded">
								<thead>
									<tr>
										<th />
										<th>Email</th>
										<th>Name</th>
										<th>Created At</th>
									</tr>
								</thead>
								<tbody>
									{users?.map((item) => (
										<tr key={item.id}>
											<td>
												<button
													className="btn btn-hyperlink"
													onClick={() => openUserEditAdminModal(item.id)}
												>
													<i className="bi bi-pencil-square" />
												</button>
											</td>
											<td>{item.email || '-'}</td>
											<td className="dashboard-username-cell">
												{item.name || '-'}
											</td>
											<td className="dashboard-date-time-cell">
												{item.created_at || '-'}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<Paginator
							currentPage={currentPage}
							totalPages={totalPages}
							setPage={(pageNum) =>
								dispatch(fetchAdminUsers('created_at|desc', pageNum, 10))
							}
						/>
					</div>
				)}
			</div>
		</AdminLayout>
	);
};

export default AdminUsers;
